// Source viewer shortcuts for the Shortcuts dialog: zoom in, out and fit width, next and previous page, active while the viewer (or nothing else) has focus; highlights are toggled by the screen that owns them.
import type { ShortcutDef } from "@/app/shortcuts";

export const SOURCE_SHORTCUTS: readonly ShortcutDef[] = [
  { id: "source-zoom", keys: [["+"], ["−"]], description: "Zoom the page in or out" },
  { id: "source-fit", keys: [["0"]], description: "Fit the page to the viewer width" },
  { id: "source-pages", keys: [["Page Down"], ["Page Up"]], description: "Next or previous page" },
  { id: "source-highlights", keys: [["H"]], description: "Show or hide highlights (original PDF)" },
];
